import request from '@/utils/request'

//获取按钮地址
export function findButtonById(params) {
  return request({
    url: '/sysMenu/findUserButtonByMenuId',
    method: 'get',
    params: params
  })
}
//获取menu列表
export function getMenuTree(params) {
  return request({
    url: '/login/nav',
    method: 'get',
    params: params
  })
}
//上传文件的地址
export function uploadImg(data) {
  return request({
    url: '/aliYun/uploadFileToServer',
    method: 'post',
    data,
    ContentType: 'multipart/form-data'
  })
}
//删除上传文件
export function deleteImg(params) {
  return request({
    url: '/aliYun/deleteImgFromAliYunOSS',
    method: 'get',
    params
  })
}
// //上传图片的地址
// export function uploadMarkImg(data) {
//   return request({
//     url: '/aliYun/uploadMarkImg',
//     method: 'post',
//     data,
//     ContentType: 'multipart/form-data'
//   })
// }
